/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/PerformanceIndicatorDataFilter', 'model/PerformanceIndicatorQuarterData', 'model/CorporateStructureLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/PerformanceIndicatorDataFilter'), require('../model/PerformanceIndicatorQuarterData'), require('../model/CorporateStructureLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.PerformanceIndicatorQuarterDataApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.PerformanceIndicatorDataFilter, root.ForStractionServiceApi.PerformanceIndicatorQuarterData, root.ForStractionServiceApi.CorporateStructureLink);
  }
}(this, function(ApiClient, PerformanceIndicatorDataFilter, PerformanceIndicatorQuarterData, CorporateStructureLink) {
  'use strict';

  /**
   * PerformanceIndicatorQuarterData service.
   * @module api/PerformanceIndicatorQuarterDataApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new PerformanceIndicatorQuarterDataApi. 
   * @alias module:api/PerformanceIndicatorQuarterDataApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataClearPut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataClearPutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * clear
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorDataFilter>} body 
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataClearPutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorQuarterDataClearPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataClearPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataClearPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/clear', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataMergeAllPut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeAllPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<'Integer'>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeAll
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorQuarterData>} body 
     * @param {Boolean} rollOverLevels 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.aggregationLevelID 
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeAllPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<'Integer'>}
     */
    this.performanceIndicatorQuarterDataMergeAllPut = function(_4SAPIAppID, body, rollOverLevels, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataMergeAllPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataMergeAllPut";
      }

      // verify the required parameter 'rollOverLevels' is set
      if (rollOverLevels == undefined || rollOverLevels == null) {
        throw "Missing the required parameter 'rollOverLevels' when calling performanceIndicatorQuarterDataMergeAllPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'rollOverLevels': rollOverLevels,
        'aggregationLevelID': opts['aggregationLevelID']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = ['Integer'];

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/mergeAll', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataMergeTargetActualValuePut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetActualValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetActualValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} quarter 
     * @param {Integer} indicatorID 
     * @param {Number} actual 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetActualValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorQuarterDataMergeTargetActualValuePut = function(_4SAPIAppID, body, year, quarter, indicatorID, actual, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorQuarterDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'quarter' is set
      if (quarter == undefined || quarter == null) {
        throw "Missing the required parameter 'quarter' when calling performanceIndicatorQuarterDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorQuarterDataMergeTargetActualValuePut";
      }

      // verify the required parameter 'actual' is set
      if (actual == undefined || actual == null) {
        throw "Missing the required parameter 'actual' when calling performanceIndicatorQuarterDataMergeTargetActualValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'quarter': quarter,
        'indicatorID': indicatorID,
        'actual': actual,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/mergeTargetActualValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataMergeTargetBudgetValuePut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetBudgetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetBudgetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} quarter 
     * @param {Integer} indicatorID 
     * @param {Number} budget 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetBudgetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorQuarterDataMergeTargetBudgetValuePut = function(_4SAPIAppID, body, year, quarter, indicatorID, budget, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorQuarterDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'quarter' is set
      if (quarter == undefined || quarter == null) {
        throw "Missing the required parameter 'quarter' when calling performanceIndicatorQuarterDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorQuarterDataMergeTargetBudgetValuePut";
      }

      // verify the required parameter 'budget' is set
      if (budget == undefined || budget == null) {
        throw "Missing the required parameter 'budget' when calling performanceIndicatorQuarterDataMergeTargetBudgetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'quarter': quarter,
        'indicatorID': indicatorID,
        'budget': budget,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/mergeTargetBudgetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataMergeTargetForecastValuePut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetForecastValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetForecastValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} quarter 
     * @param {Integer} indicatorID 
     * @param {Number} forecast 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetForecastValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorQuarterDataMergeTargetForecastValuePut = function(_4SAPIAppID, body, year, quarter, indicatorID, forecast, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorQuarterDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'quarter' is set
      if (quarter == undefined || quarter == null) {
        throw "Missing the required parameter 'quarter' when calling performanceIndicatorQuarterDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorQuarterDataMergeTargetForecastValuePut";
      }

      // verify the required parameter 'forecast' is set
      if (forecast == undefined || forecast == null) {
        throw "Missing the required parameter 'forecast' when calling performanceIndicatorQuarterDataMergeTargetForecastValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'quarter': quarter,
        'indicatorID': indicatorID,
        'forecast': forecast,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/mergeTargetForecastValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataMergeTargetGoalValuePut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetGoalValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetGoalValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} quarter 
     * @param {Integer} indicatorID 
     * @param {Number} goal 
     * @param {Object} opts Optional parameters
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetGoalValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorQuarterDataMergeTargetGoalValuePut = function(_4SAPIAppID, body, year, quarter, indicatorID, goal, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorQuarterDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'quarter' is set
      if (quarter == undefined || quarter == null) {
        throw "Missing the required parameter 'quarter' when calling performanceIndicatorQuarterDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorQuarterDataMergeTargetGoalValuePut";
      }

      // verify the required parameter 'goal' is set
      if (goal == undefined || goal == null) {
        throw "Missing the required parameter 'goal' when calling performanceIndicatorQuarterDataMergeTargetGoalValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'quarter': quarter,
        'indicatorID': indicatorID,
        'goal': goal,
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/mergeTargetGoalValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataMergeTargetValuePut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetValuePutCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * mergeTargetValue
     * @param {String} _4SAPIAppID 
     * @param {module:model/CorporateStructureLink} body 
     * @param {Integer} year 
     * @param {Integer} quarter 
     * @param {Integer} indicatorID 
     * @param {Object} opts Optional parameters
     * @param {Number} opts.actual 
     * @param {Number} opts.goal 
     * @param {Number} opts.budget 
     * @param {Number} opts.forecast 
     * @param {Integer} opts.sourceID 
     * @param {String} opts.comment  (default to )
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataMergeTargetValuePutCallback} callback The callback function, accepting three arguments: error, data, response
     */
    this.performanceIndicatorQuarterDataMergeTargetValuePut = function(_4SAPIAppID, body, year, quarter, indicatorID, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataMergeTargetValuePut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataMergeTargetValuePut";
      }

      // verify the required parameter 'year' is set
      if (year == undefined || year == null) {
        throw "Missing the required parameter 'year' when calling performanceIndicatorQuarterDataMergeTargetValuePut";
      }

      // verify the required parameter 'quarter' is set
      if (quarter == undefined || quarter == null) {
        throw "Missing the required parameter 'quarter' when calling performanceIndicatorQuarterDataMergeTargetValuePut";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling performanceIndicatorQuarterDataMergeTargetValuePut";
      }


      var pathParams = {
      };
      var queryParams = {
        'year': year,
        'quarter': quarter,
        'indicatorID': indicatorID,
        'actual': opts['actual'],
        'goal': opts['goal'],
        'budget': opts['budget'],
        'forecast': opts['forecast'],
        'sourceID': opts['sourceID'],
        'comment': opts['comment']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = null;

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/mergeTargetValue', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the performanceIndicatorQuarterDataSearchPut operation.
     * @callback module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataSearchPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/PerformanceIndicatorQuarterData>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * search
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/PerformanceIndicatorQuarterData>} body 
     * @param {Object} opts Optional parameters
     * @param {Date} opts.startDate 
     * @param {Date} opts.endDate 
     * @param {module:api/PerformanceIndicatorQuarterDataApi~performanceIndicatorQuarterDataSearchPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/PerformanceIndicatorQuarterData>}
     */
    this.performanceIndicatorQuarterDataSearchPut = function(_4SAPIAppID, body, opts, callback) {
      opts = opts || {};
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling performanceIndicatorQuarterDataSearchPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling performanceIndicatorQuarterDataSearchPut";
      }


      var pathParams = {
      };
      var queryParams = {
        'startDate': opts['startDate'],
        'endDate': opts['endDate']
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [PerformanceIndicatorQuarterData];

      return this.apiClient.callApi(
        '/PerformanceIndicatorQuarterData/search', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
